import { Badge, Tooltip } from '@mui/material';
import { useVersionHistory } from '../../hooks/useVersionHistory';
import { useParams } from 'react-router-dom';

interface BadgeEventChangesProps {
  section: string;
}

export const BadgeEventChanges: React.FC<BadgeEventChangesProps> = ({ section }) => {
  const { id } = useParams();
  const { hasSectionChanged } = useVersionHistory(Number(id));
  const changes = hasSectionChanged(section);
  const user = JSON.parse(localStorage.getItem('user') || '{}')

  if (!changes || changes.length === 0) {
    return null;
  }

  let badgeColor: 'error' | 'primary' = 'error';
  if (user.role === 'REQUESTER') {
    badgeColor = 'primary';
  }

  return (
    <Tooltip
      title={
        <div style={{ whiteSpace: 'pre-line' }}>
          Changes to this section:<br/>
          {changes.map(change => change.field).join('\n') || ''}
          <br/>
          (Details in Version History)
        </div>
      }
      arrow
      placement="right"
    >
      <Badge color={badgeColor} variant="dot" sx={{ px: "5px" }}>
      </Badge>
    </Tooltip>
  );
};
